import E, { forwardRef as O, useRef as m, useEffect as o } from "react";
import { Chart as T } from "./index.es64.js";
const b = "label";
function h(t, e) {
  typeof t == "function" ? t(e) : t && (t.current = e);
}
function j(t, e) {
  const r = t.options;
  r && e && Object.assign(r, e);
}
function w(t, e) {
  t.labels = e;
}
function y(t, e) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : b;
  const l = [];
  t.datasets = e.map((a) => {
    const s = t.datasets.find((i) => i[r] === a[r]);
    return !s || !a.data || l.includes(s) ? {
      ...a
    } : (l.push(s), Object.assign(s, a), s);
  });
}
function k(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : b;
  const r = {
    labels: [],
    datasets: []
  };
  return w(r, t.labels), y(r, t.datasets, e), r;
}
function _(t, e) {
  const { height: r = 150, width: l = 300, redraw: a = !1, datasetIdKey: s, type: i, data: u, options: c, plugins: v = [], fallbackContent: C, updateMode: p, ...R } = t, d = m(null), n = m(null), f = () => {
    d.current && (n.current = new T(d.current, {
      type: i,
      data: k(u, s),
      options: c && {
        ...c
      },
      plugins: v
    }), h(e, n.current));
  }, g = () => {
    h(e, null), n.current && (n.current.destroy(), n.current = null);
  };
  return o(() => {
    !a && n.current && c && j(n.current, c);
  }, [
    a,
    c
  ]), o(() => {
    !a && n.current && w(n.current.config.data, u.labels);
  }, [
    a,
    u.labels
  ]), o(() => {
    !a && n.current && u.datasets && y(n.current.config.data, u.datasets, s);
  }, [
    a,
    u.datasets
  ]), o(() => {
    n.current && (a ? (g(), setTimeout(f)) : n.current.update(p));
  }, [
    a,
    c,
    u.labels,
    u.datasets,
    p
  ]), o(() => {
    n.current && (g(), setTimeout(f));
  }, [
    i
  ]), o(() => (f(), () => g()), []), /* @__PURE__ */ E.createElement("canvas", {
    ref: d,
    role: "img",
    height: r,
    width: l,
    ...R
  }, C);
}
const I = /* @__PURE__ */ O(_);
export {
  I as Chart
};
//# sourceMappingURL=index.es65.js.map
